import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "TableData",
  initialState: [],
  reducers: {
    setData: (state, action) => {
      return action.payload;
    },
  },
});

export const { setData } = dataSlice.actions;

export default dataSlice.reducer;
